module.exports = __webpack_public_path__ + "static/img/bbc-benefit2.f1b4172.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/bbc-benefit2.png
// module id = 1071
// module chunks = 1